import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SugargooSpreadsheetGuide from "@/pages/article/page";
import SugargooShippingCost from "@/pages/shipping-cost/page";
import IsSugargooLegit from "@/pages/legit/page";
import SugargooCoupon from "@/pages/coupon/page";
import SugargooWarehouse from "@/pages/warehouse/page";
import SugargooVsCompetitors from "@/pages/vs-competitors/page";
import SugargooBestFinds from "@/pages/best-finds/page";
import SugargooBeginnerTutorial from "@/pages/beginner-tutorial/page";
import SugargooSaveMoney from "@/pages/save-money/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <SugargooSpreadsheetGuide />,
  },
  {
    path: "/sugargoo-shipping-cost",
    element: <SugargooShippingCost />,
  },
  {
    path: "/is-sugargoo-legit",
    element: <IsSugargooLegit />,
  },
  {
    path: "/sugargoo-coupon",
    element: <SugargooCoupon />,
  },
  {
    path: "/sugargoo-warehouse",
    element: <SugargooWarehouse />,
  },
  {
    path: "/sugargoo-vs-competitors",
    element: <SugargooVsCompetitors />,
  },
  {
    path: "/sugargoo-best-finds",
    element: <SugargooBestFinds />,
  },
  {
    path: "/sugargoo-beginner-tutorial",
    element: <SugargooBeginnerTutorial />,
  },
  {
    path: "/sugargoo-save-money",
    element: <SugargooSaveMoney />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;